import React from 'react';
import { Flex, Skeleton } from 'antd';
import './DataViewsLoadingSkeleton.css';

const TABLE_GRID_TEMPLATE =
  '80px minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) 140px' as const;

const BODY_ROWS = 5;

const TOOLBAR_CONTROL_WIDTHS = [156, 92, 96, 32, 140, 112] as const;

export function DataViewsLoadingSkeleton(): React.ReactElement {
  return (
    <>
      <div style={{ padding: '24px' }}>
        <Skeleton
          active
          title={{ width: 280, style: { marginTop: 0, marginBottom: 0, height: 28 } }}
          paragraph={false}
        />
      </div>
      <div
        className="data-views-filter-section"
        style={{
          padding: '0px 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 16,
          flexWrap: 'wrap',
        }}
      >
        <Skeleton.Input
          active
          size="large"
          style={{
            width: 448,
            maxWidth: '100%',
            height: 39,
            borderRadius: 10,
          }}
        />
        {/* The page's six controls, in order: Table/Kanban, Filters, Export, Row fill
            (icon), Configure view, Settings — at the control height they render at. */}
        <Flex gap={8} align="center" wrap="wrap">
          {TOOLBAR_CONTROL_WIDTHS.map((width, index) => (
            <Skeleton.Button
              key={index}
              active
              style={{
                width,
                minWidth: width,
                height: 'var(--silia-ctl-height)',
                borderRadius: 'var(--silia-radius-md)',
              }}
            />
          ))}
        </Flex>
      </div>
      <div style={{ padding: 24 }}>
        <div className="data-views-table-container">
          <div className="data-views-skeleton-table">
            <div
              className="data-views-skeleton-table-header"
              style={{ gridTemplateColumns: TABLE_GRID_TEMPLATE }}
            >
              {[0, 1, 2, 3, 4].map((colIndex) => (
                <div
                  key={`sk-h-${colIndex}`}
                  className={`data-views-skeleton-table-cell data-views-skeleton-table-cell--header${
                    colIndex === 0 ? ' data-views-skeleton-table-cell--narrow' : ''
                  }`}
                >
                  <Skeleton.Node
                    active
                    style={{
                      width: colIndex === 0 ? 40 : colIndex === 4 ? 100 : 'min(88%, 120px)',
                      height: 16,
                    }}
                  />
                </div>
              ))}
            </div>
            {Array.from({ length: BODY_ROWS }).map((_, rowIndex) => (
              <div
                key={`sk-r-${rowIndex}`}
                className="data-views-skeleton-table-row"
                style={{ gridTemplateColumns: TABLE_GRID_TEMPLATE }}
              >
                {[0, 1, 2, 3, 4].map((colIndex) => (
                  <div
                    key={`sk-c-${rowIndex}-${colIndex}`}
                    className={`data-views-skeleton-table-cell${
                      colIndex === 0 ? ' data-views-skeleton-table-cell--narrow' : ''
                    }`}
                  >
                    <Skeleton.Node
                      active
                      style={{
                        width:
                          colIndex === 0
                            ? 32
                            : colIndex === 4
                              ? 24
                              : `${68 + ((rowIndex + colIndex) % 4) * 8}%`,
                        height: 18,
                        maxWidth: colIndex === 4 ? 24 : '100%',
                      }}
                    />
                  </div>
                ))}
              </div>
            ))}
            <div className="data-views-skeleton-table-tfoot">
              <Skeleton.Node active style={{ width: 96, height: 24 }} />
            </div>
          </div>
          <Flex justify="space-between" align="center" className="data-views-table-footer">
            <Skeleton
              active
              title={{ width: 200, style: { margin: 0, height: 16 } }}
              paragraph={false}
            />
            <Flex gap={8} align="center">
              <Skeleton.Button active style={{ width: 32, height: 32 }} />
              <Skeleton.Button active style={{ width: 32, height: 32 }} />
              <Skeleton.Button active style={{ width: 28, height: 32 }} />
              <Skeleton.Button active style={{ width: 28, height: 32 }} />
            </Flex>
          </Flex>
        </div>
      </div>
    </>
  );
}
